<template>
  <div>
    <div class="mx-auto max-w-5xl px-4 pt-8 pb-12 text-center sm:space-y-4 sm:px-6 sm:py-12 lg:px-6">
      <div class="space-y-5 sm:space-y-4 sm:mx-auto sm:max-w-lg lg:max-w-5xl">
        <p class="mt-4 text-4xl font-bold leading-6 text-gray-800">&#127881;</p>
        <p class="mt-4 text-xl font-bold leading-6 text-gray-800">Herzlichen Glückwunsch</p>
        <h2 class="text-3xl font-bold text-green-400 sm:text-4xl">
          Eine E-Mail mit der Reservierung ist auf dem Weg zu Ihnen.
        </h2>
        <p class="mt-4 text-xl font-bold leading-6 text-gray-800">
          Ihre Auftragsnummer lautet:
          <span class="font-bold text-green-400"> {{ tenant.prefixedOrderId }}</span>
        </p>
      </div>
    </div>
    <!-- START How it works? -->
    <div id="sofunktionierts" class="bg-gray-50 scroll-m-20">
      <div class="max-w-7xl mx-auto py-12 px-4 text-center sm:px-6 lg:px-8 lg:py-12">
        <div class="space-y-12">
          <div class="space-y-5 sm:mx-auto sm:space-y-4 lg:max-w-5xl">
            <h2 class="text-3xl font-bold text-green-400 sm:text-4xl">
              Und so geht es weiter:
            </h2>
          </div>
          <ul class="mx-auto space-y-16 sm:grid sm:gap-16 sm:space-y-0 lg:max-w-7xl grid-cols-2">
            <li>
              <div class="space-y-6">
                  <img class="mx-auto object-cover h-40 w-40 rounded-full xl:w-56 xl:h-56"
                      src="/images/e-mail-erhalten.png"
                      alt=""
                      loading="lazy">
                  <div class="space-y-2">
                      <div class="text-lg leading-6 space-y-1">
                          <h3 class="font-medium text-green-400">1. Reservierung herunterladen</h3>
                          <p class="text-gray-600">Laden Sie sich jetzt Ihre Reservierungsbestätigung herunter. Diese steht Ihnen in <a href="/konto" class="text-green-400 underline">Ihrem Konto</a> zur Verfügung. Nehmen Sie diese mit zu Wohnungsbesichtigungen.</p>
                      </div>
                  </div>
              </div>
            </li>
            <li>
              <div class="space-y-6">
                  <img class="mx-auto object-cover h-40 w-40 rounded-full xl:w-56 xl:h-56"
                      src="/images/schritt4.png"
                      alt=""
                      loading="lazy">
                  <div class="space-y-2">
                      <div class="text-lg leading-6 space-y-1">
                          <h3 class="font-medium text-green-400">2. Wohnung bekommen? Bürgschaft abschließen!</h3>
                          <p class="text-gray-600">Wenn Sie die Wohnung bekommen haben, wandeln Sie Ihre Reservierung in eine gültige Bürgschaft um. Nach erfolgreichem Abschluss landet Ihre digitale Urkunde direkt in Ihrem heysafe Konto.</p>
                      </div>
                  </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
    <!-- END How it works? -->
  <div class="mx-auto max-w-5xl px-4 py-10 text-center sm:space-y-4 sm:px-6 lg:px-6">
    <div class="sm:flex sm:justify-center">
      <a href="/konto"
        class="flex w-full items-center justify-center rounded-full border border-transparent bg-green-400 px-4 py-3 text-base font-medium text-white shadow-sm hover:bg-green-300 sm:w-auto sm:px-8">
        Reservierung im Konto herunterladen
      </a>
    </div>
    <p class="mt-6 text-sm leading-6 text-gray-600"> Keine E-Mail erhalten? Haben Sie schon Ihren Spam Ordner
      gecheckt?<br> Ihre angegebene E-Mail-Adresse lautet: {{ tenant.formValues.start_email }}.<br><br>
      Die E-Mail-Adresse ist nicht korrekt? Dann starten Sie hier nochmal von vorne:
      <a class="underline" href="/app/start?id=new">Jetzt neu starten</a><br><br>
      Hier sind unsere <a href="/agb" class="text-green-400">AGB</a> das <a href="/impressum"  class="text-green-400">Impressum</a>,
      die <a href="/datenschutz" class="text-green-400">Datenschutzbestimmungen</a>, und die <a href="/agb" class="text-green-400">Widerrufsbelehrung</a>.
    </p>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useTenantStore } from "../stores/tenant";
import { useProgressBarStore } from "../stores/progress-bar";

const props = defineProps({
  id: String,
})

const progressBar = useProgressBarStore();
const tenant = useTenantStore();

onMounted(() => {
  tenant.loadUserData(props.id);
  progressBar.setStepsState('danke');
})

</script>
